// BJS 2025040 - Migrated to angular component ConsignmentPlansDeliveryComponent

//(function () {
//	'use strict';

//	var module = angular.module("imApp");

//	module.factory("consignmentPlansDeliveryService", ['p2DataTaskService', function (p2DataTaskService) {
//		var service = {
//			loadDeliveryMethods: function () {
//				return p2DataTaskService.call(1693, {});
//			},
//			loadSettings: function () {
//				return p2DataTaskService.call(1692, {});
//			},
//			loadPlans: function (parms) {
//				return p2DataTaskService.call(1679, parms);
//			},
//			remember: function (variablename, variablevalue) {
//				return p2DataTaskService.call(616, {
//					variablename: variablename,
//					variablevalue: variablevalue
//				});
//			},
//			updateColumnResize: function (parms) {
//                return p2DataTaskService.call(1457, parms);
//			}
//		};

//		return service;
//	}]);
//})();
